/**
 * Dealer profile inventory eligibility (Dealer Profile M4).
 */
import { shouldShowListingInSearch } from "../automapListing/listingVisibility";
import { getVehicleDetailHref } from "../automapListing/listingDetailRoutes";
import { normalizeDealerSlug } from "./dealerSlug";

export function listingBelongsToDealer(listing, dealer) {
  if (!listing || !dealer) return false;
  if (dealer.id && listing.dealerId && String(dealer.id) === String(listing.dealerId)) {
    return true;
  }
  const dealerProfileId = dealer.dealerProfileId || dealer.id;
  if (dealerProfileId && listing.dealerProfileId && String(dealerProfileId) === String(listing.dealerProfileId)) {
    return true;
  }
  const dealerSlug = normalizeDealerSlug(dealer.slug || dealer.dealerSlug);
  const listingSlug = normalizeDealerSlug(listing.dealerSlug);
  if (dealerSlug && listingSlug && dealerSlug === listingSlug) {
    return true;
  }
  return false;
}

function hasMinimumCardData(listing) {
  if (!listing?.id) return false;
  return Boolean(listing.title || listing.make || listing.model || listing.primaryImageUrl);
}

function hasResolvableDetailLink(listing) {
  const href = getVehicleDetailHref(listing);
  return Boolean(href && href !== "/v/automap/vehicles/");
}

/**
 * @param {object|null} listing
 * @param {import('./dealerProfileTypes').DealerProfile|null|undefined} dealer
 */
export function isListingEligibleForDealerProfileInventory(listing, dealer) {
  if (!listing || !dealer) return false;
  if (!listingBelongsToDealer(listing, dealer)) return false;
  if (!shouldShowListingInSearch(listing)) return false;
  if (!hasMinimumCardData(listing)) return false;
  if (!hasResolvableDetailLink(listing)) return false;
  return true;
}

/**
 * @param {import('./dealerProfileTypes').DealerProfile|null|undefined} dealer
 * @param {object[]} listings
 * @param {{ excludeListingId?: string|null }} [options]
 */
export function getPublicDealerInventoryListings(dealer, listings = [], options = {}) {
  if (!dealer || !Array.isArray(listings)) return [];
  return listings.filter((listing) => {
    if (options.excludeListingId && listing.id === options.excludeListingId) return false;
    return isListingEligibleForDealerProfileInventory(listing, dealer);
  });
}

export function countPublicDealerInventory(dealer, listings = [], options = {}) {
  return getPublicDealerInventoryListings(dealer, listings, options).length;
}
